import { Box, Text } from '@mantine/core';
import type { RichTextPresetStyle } from '@/services/rich-text-presets.api';
import { getCalloutIconLabel } from './calloutNode';
import { createCalloutAttrs } from './presets';

interface CalloutPreviewProps {
    preset: { name: string; style: RichTextPresetStyle };
}

/** Compact preview of a callout preset shown inside the callout menu. */
export function CalloutPreview({ preset }: CalloutPreviewProps) {
    const attrs = createCalloutAttrs(preset.style);
    const iconLabel = getCalloutIconLabel(preset.style) || 'i';

    return (
        <Box
            style={{
                width: 240,
                border: `1px solid ${attrs.borderColor}`,
                backgroundColor: attrs.backgroundColor,
                color: attrs.textColor,
                padding: '8px 10px',
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                fontFamily: attrs.fontFamily,
                fontSize: 13,
                lineHeight: 1.25,
            }}
        >
            <Box
                style={{
                    width: 22,
                    height: 22,
                    borderRadius: '50%',
                    backgroundColor: attrs.iconColor,
                    color: attrs.textColor,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 12,
                    fontWeight: 700,
                    flex: '0 0 auto',
                }}
            >
                {iconLabel}
            </Box>
            <Box style={{ minWidth: 0 }}>
                <Text size="xs" fw={700} c="inherit" truncate>
                    {preset.name}
                </Text>
                <Text size="xs" c="inherit" opacity={0.8} truncate>
                    Callout text preview
                </Text>
            </Box>
        </Box>
    );
}
